import { useQuery } from '@tanstack/react-query';
import { PunchSessionAdjustment } from '@models/punchSessionAdjustment.model';
import { punchSessionAdjustmentService } from '@services/punchSessionAdjustment';

export const PUNCH_SESSION_ADJUSTMENTS_BY_USER_KEY = ['punchSessionAdjustments', 'byUser'];

interface UsePunchSessionAdjustmentsByUserOptions {
  enabled?: boolean;
}

export const usePunchSessionAdjustmentsByUser = (
  userId: string | null | undefined,
  options: UsePunchSessionAdjustmentsByUserOptions = {},
) => {
  const { enabled = true } = options;
  return useQuery<PunchSessionAdjustment[], Error>({
    queryKey: [...PUNCH_SESSION_ADJUSTMENTS_BY_USER_KEY, userId ?? null],
    queryFn: async () => {
      if (!userId) return [];
      return await punchSessionAdjustmentService.getByUser(userId);
    },
    enabled: enabled && !!userId,
  });
};

export default usePunchSessionAdjustmentsByUser;
